$(function(){
    $('.MojeEucBlockEshopCarousel').owlCarousel({
        loop: true,
        nav: true,
        items: 4,
        navText: [
            '<div class="shadow bg-white rounded-circle overflow-hidden p-3"><svg class="icon-chevron-left-large text-primary"><use xlink:href="#icon-chevron-left"></use></svg></div>',
            '<div class="shadow bg-white rounded-circle overflow-hidden p-3"><svg class="icon-chevron-right-large text-primary"><use xlink:href="#icon-chevron-right"></use></svg></div>'
        ],
        stageClass: 'owl-stage d-flex',
        dots: false,
        margin: 5,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            976: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    });
});